import { APP_TAGLINE } from "@custos/core";
import { Logo, NetworkBadge, SystemMessages } from "@custos/ui";
import type { ReactNode } from "react";
import { useConfig, usePublicMessages } from "../lib/queries";

/** Signed-out screens: aurora backdrop with a dark card floating over it (D49). */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  const config = useConfig();
  const notices = usePublicMessages();
  return (
    <div className="relative flex min-h-dvh flex-col items-center overflow-hidden px-4 pt-5 pb-10">
      <div
        aria-hidden
        className="bg-aurora pointer-events-none absolute inset-x-0 top-0 h-[22rem] rounded-b-[44px] sm:h-[26rem]"
      />
      <div className="relative w-full max-w-md">
        <div className="mb-8 flex items-center justify-between gap-3 text-white sm:mb-12">
          <span className="[&_span]:text-white">
            <Logo />
          </span>
          {config.data && <NetworkBadge label={config.data.badge} />}
        </div>
        <div className="mb-6 px-1 text-white">
          <h1 className="font-heading text-[32px] leading-tight font-medium tracking-[-0.03em]">{title}</h1>
          {subtitle && <p className="mt-2 text-base text-white/80">{subtitle}</p>}
        </div>
        {/* Team notices marked for the login page (D78): everyone sees them, nothing to close. */}
        <SystemMessages className="mb-4" messages={notices.data ?? []} />
        <div className="animate-rise rounded-[32px] border border-line bg-surface p-5 shadow-2xl sm:p-7">
          {children}
        </div>
        <p className="mt-6 text-center text-xs text-muted">{APP_TAGLINE}</p>
      </div>
    </div>
  );
}
